__turbopack_context__.v({
  "link": "nav-link-module-scss-module__CrkOyq__link",
});
